import React, { Component } from 'react';
import LoadingComponent from '../../components/commonComponents/LoadingComponent';
import StepOne from './steps/stepone';
import StepTwo from './steps/steptwo';
import DatasetFilter from '../commonComponents/DatasetFilter';
import CallAPI from '../commonComponents/AxiosHelper';
import getParametersFromString from '../commonComponents/Helper';
import ErrorComponent from '../commonComponents/ErrorComponent';
// import asyncFilter from '../commonComponents/Helper';

export default class Synonym extends Component {

    constructor(props) {
        super(props);
        this.state = { columns: null, accessError:null, }

        this.fetchSynonymData = this.fetchSynonymData.bind(this);
    }
    componentWillMount() {
        this.setState({ columns: null });
        this.fetchSynonymData();
    }
    componentDidUpdate(prevProps,nextState) {
        jQuery('[data-toggle="tooltip"]').tooltip();
        if (prevProps.datasetValue !== this.props.datasetValue) {
            let that = this;
            this.fetchSynonymData();
        }
    }

    fetchSynonymData(){
        let that = this;
        that.setState({ columns: null ,accessError:null})

        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: this.props.datasetValue
        }
        CallAPI('get', '/app/getheaderdataforrefine', null, params, 0, function (response) {
            if(response?.status==false){
                checkIfMaintenanceModeOn(response)
            }else if(response?.status==500){
                that.setState({accessError:true});
            }
            that.setState({ columns: response })
        },this.props.authData)
    }

    getUpload(e) {
        var files = document
            .getElementById('jsonData')
            .files;
        var reader = new FileReader();
        var that = this;
        that.setState({ columns: null });
        reader.onload = function (e) {
            dataToDisp = JSON.parse(e.target.result);
            that.setState({ columns: dataToDisp.allColumns });
        }
        reader.readAsText(files.item(0));
        e.preventDefault();
    }
    handleTabChange(e) {
        var tabSelected = jQuery(e.target).attr('href');
        var newURL = window.location.href;
        if (tabSelected == '#propertyTab') {
            newURL = window.location.origin + window.location.pathname + '?type=property';
        } else if (tabSelected == '#metricTab') {
            newURL = window.location.origin + window.location.pathname + '?type=metric';
        } else if (tabSelected == '#metricsection') {
            newURL = window.location.origin + window.location.pathname + '?type=format';
        } else if (tabSelected == '#synonyms') {
            newURL = window.location.origin + window.location.pathname + '?type=label';
        }
        history.pushState({}, null, newURL);
        this.setState({});
    }
    render() {
        var activeTab = getParametersFromString('type', location.search);
        var labelTab = "nav-link";
        if (activeTab == 'format') {
            // formatTab = 'nav-link active';
        } else {
            labelTab = 'nav-link active';
        }
        var mainData = null;
        if (this.state.columns == null) {
            mainData = <LoadingComponent />;
        }
        else if(this.state.columns.data == "error"){
            mainData = <ErrorComponent/>
        } else if (this.state.accessError) (
            mainData = <>
                <div className="wd-300">
                    <DatasetFilter />
                </div>
                <div className="d-flex">
                    <div class="alert alert-danger h-25 mg-b-0 mg-t-5" role="alert"><i data-feather="alert-circle" class="mg-r-10"></i>
                        This dataset don’t have admin access. Kindly provide admin access. <a href="/admin/useraccess" class="alert-link" target="_blank">Click here for grant permission</a>
                    </div>
            </div></>
        )  
        else {
            if (activeTab == "format") {
                mainData = (<>
                    <div className="wd-300">
                        <DatasetFilter />
                    </div>
                    <div className='col-sm-12 box' id="step1">
                        <div className="box-content">
                            {this.state.columns.metric.length > 1 ? <StepTwo data={this.state.columns['metric']} datasetValue={this.props.datasetValue} fetchSynonym={this.fetchSynonymData} authData={this.props.authData} /> : <><div className="d-flex">
                                <div class="alert alert-danger h-25 mg-b-0 mg-t-5" role="alert"><i data-feather="alert-circle" class="mg-r-10"></i>
                                This dataset has no tags.
                            </div>
            </div></>}
                    </div>
                </div></>);
            }
            else if (activeTab == "property" || (activeTab == "metric")){
                mainData = (<div>
                    <div className='col-sm-12 box mg-t-15' id="step1">
                        <div className="box-content">
                            {this.state.columns.metric.length >= 1 ? <StepOne data={this.state.columns['labels']} datasetValue={this.props.datasetValue} activeTab={activeTab} fetchSynonym={this.fetchSynonymData} authData={this.props.authData} /> : <><div className="d-flex">
                                <div class="alert alert-danger h-25 mg-b-0 mg-t-5 row" role="alert"><i data-feather="alert-circle" class="mg-r-10"></i>
                                    This dataset has no tags.
                                </div>
                            </div></>}
                        </div>
                    </div>
                </div>);
            }

            mainData = <>
                <div className="wd-300">
                    <DatasetFilter />
                </div>
                {mainData}
            </>
            // dataAppend =
            // var dataAppendNew = <StepTwo data={this.state.columns['metric']} />;
            // dataAppendNew = <div>
            
        }
        return (
            <div id="main-content">
                {/* <div className='col-md-12'>
                    <h4>
                        <a href="/admin/home" toolTip="Go Back">
                            <button className="btn btn-contrast"><i className="fa fa-arrow-left "></i></button>
                        </a>{"  Synonyms"}</h4>

                </div> */}

                <div className="tabbable">
                    {/* <DatasetFilter /> */}
                    {/* <ul className="nav nav-line" style={{ position: 'unset' }} onClick={this.handleTabChange.bind(this)}> */}
                    {/* style={{ marginLeft: '-390px' }} */}
                    {/* style={{ marginLeft: '-240px' }} */}
                    {/* marginTop: "35px" */}
                    {/* <li className={labelTab} > */}
                    {/* <li className="nav-item">
                                <a className={labelTab} data-toggle="tab" id='label' href="#synonyms"><i className="fas fa-outdent"></i>{"Label & Synonyms"}</a>
                            </li> */}
                    {/* <li className="nav-item" >
                                <a className={formatTab} data-toggle="tab" id='metricsection' href="#metricsection"><i className="fas fa-cash-register"></i>{"Metric Units and Formatting"}</a>
                            </li> */}
                    {/* </ul> */}
                    {mainData}
                    
                    {/* <div className={"tab-pane " + formatTab} style={{ marginBottom: "-41px" }} id="metricsection">
                                {dataAppendNew}
                            </div> */}
                </div>
            </div>
        );
    }
};

